<div class="container-fluid  row_banner pb-5">
    <app-header></app-header>
    <div class="container">
        <div class="row  text-center justify-content-center">
            <div class="col-lg-9 col-md-9 mb-4" id="footergrammartext">
                <h1 class="w-100 fnt-w600-40 tit">Professional Email Writer Tool</h1>
                <span class="w-100 d-inline-block main_text mt-40">Compose polished, clear professional emails that communicate your message with precision.</span>
            </div>
        </div>
        <!-- Editor -->
        <div class="custom-card">
            <div style="height: 25px;">
                <p class="text-left px-3" id="eFsubText2" [ngStyle]="{'color': color}" *ngIf="eFsubIF ">
                    <i class="fas fa-check-circle" aria-hidden="true"></i>{{eFsubText2}}
                </p>
            </div>

            <form class="aiform">
                <div>
                    <div class="row" style="justify-content: space-between;">
                        <div class="col form-group ">
                            <label for="" class="aiLabel">Recipient</label>
                            <input id="form_recipient" type="text" name="form_recipient" class="form-control bd-light"    spellcheck="false" data-gramm="false"
                                placeholder="Example: John Doe, Marketing Manager *"   value="" />
                        </div>
                        <div class="col form-group ">
                            <label for="" class="aiLabel">Subject </label>
                            <input id="form_subject" type="text" name="form_subject" class="form-control bd-light"    spellcheck="false" data-gramm="false"
                                placeholder=" Example: Follow-up on Quarterly Sales Report*"
                                 value="" />
                        </div>
                    </div>
                    <div class="">
                        <label for="description" class="aiLabel">Add Details</label>
                        <textarea id="form_detail" name="form_detail" class="form-control bd-light" rows="4" spellcheck="false" data-gramm="false"
                           placeholder="Example: Write an email about that I wanted to check in on the status of the quarterly sales report. Could you provide an update on the figures and any key insights?" ></textarea>
                    </div>

                </div>
                <br>
                <div class="input-group-append btn-submit-div">
                    <button type="submit" class="btn btn-dark m-0 btn-submit" value="Submit"
                        (click)="eFormSubmission($event)">
                        <i class="fa fa-spinner fa-pulse ml-2 mr-1" *ngIf="loaderAlert"></i> Submit </button>
                        <button  *ngIf="output_display"   type="submit" class="btn btn-dark m-0 btn-refresh "
                        (click)="reFreshWindow()"
                           >
                      Start New Search  </button>
                </div>

            </form>
            <div class="outputDisplay mt-3" *ngIf="output_display">
                <div class="outputtop">
                    <div>
                        <p class="outputtopTxt">
                            Your slogan ideas are below
                        </p>
                    </div>

                    <div class="outputtopButton tooltipss" (click)="copyToClipboard()" role="button" tabindex="0"
                        (keydown.enter)="copyToClipboard()">
                        <span class="tooltiptext">Copy</span>
                        <span class="tooltiptext" id="copried_txt" *ngIf="copiedtext">Copied</span>
                        <img src="../../assets/images/About us-assets/copy-frame.svg" alt="copy-frame" height="18px"
                            width="18px">
                        <p class="">Copy to clipboard</p>
                    </div>
                </div>
                <div class="responseD">
                    <div class="responseO" [innerHTML]="output"></div>

                </div>
            </div>
        </div>
    </div>
</div>


<a (click)="scrollToTop()" *ngIf="shouldShowButton" id="scroll-to-top" data-tooltip="Go to top">

  <app-icons-free-tools name="goToTopIcon" />
</a>

<app-footer></app-footer>
